module.exports = __webpack_public_path__ + "img/22.dc3ac7a7.svg";